import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Menu = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.5C2.72386 5.5 2.5 5.72386 2.5 6C2.5 6.27614 2.72386 6.5 3 6.5H20.5C20.7761 6.5 21 6.27614 21 6C21 5.72386 20.7761 5.5 20.5 5.5H3ZM2.5 12C2.5 11.7239 2.72386 11.5 3 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12ZM2.5 18C2.5 17.7239 2.72386 17.5 3 17.5H20.5C20.7761 17.5 21 17.7239 21 18C21 18.2761 20.7761 18.5 20.5 18.5H3C2.72386 18.5 2.5 18.2761 2.5 18Z"
        fill={color}
      />
    </svg>
  )
})

export default Menu
